module.exports = __webpack_public_path__ + "static/image-222fa98b7d932f8a490ca93ca105b1a5.png";